module.exports = __webpack_public_path__ + "images/learningCenterIcon-effd170ca7a80e2e0cdcc8ead3f8b18a.svg";